import React, { useState } from 'react';
import { Navbar, Nav, Container, Button, Badge, Dropdown } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { FiCalendar, FiSettings, FiBell, FiLogOut, FiUser, FiCreditCard, FiMenu, FiBarChart, FiDollarSign, FiStar, FiUsers } from 'react-icons/fi';

const Header = () => {
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <Navbar expand="lg" className="navbar-custom">
      <Container fluid="lg">
        <Navbar.Brand as={Link} to="/" className="brand-logo">
          <FiCalendar className="me-2" style={{ fontSize: '1.5rem' }} />
          Triple B
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/" className="nav-link-custom">
              Home
            </Nav.Link>
            {isAuthenticated && user?.business && (
              <>
                <Nav.Link as={Link} to="/dashboard" className="nav-link-custom">
                  Dashboard
                </Nav.Link>
                <Nav.Link as={Link} to="/appointments" className="nav-link-custom">
                  Appointments
                </Nav.Link>
                <Dropdown as={Nav.Item}>
                  <Dropdown.Toggle as={Nav.Link} className="nav-link-custom">
                    <FiMenu className="me-1" />
                    More
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item as={Link} to="/services">
                      Services
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to="/availability">
                      Availability
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to="/notifications">
                      <FiBell className="me-1" />
                      Notifications
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item as={Link} to="/dashboard/subscription">
                      <FiCreditCard className="me-1" />
                      Subscription
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to="/dashboard/calendar">
                      <FiCalendar className="me-1" />
                      Calendar Sync
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to="/dashboard/analytics">
                      <FiBarChart className="me-1" />
                      Analytics
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to="/dashboard/quickbooks">
                      <FiDollarSign className="me-1" />
                      QuickBooks
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item as={Link} to="/dashboard/users">
                      <FiUsers className="me-1" />
                      Users
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to="/dashboard/settings">
                      <FiSettings className="me-1" />
                      Settings
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </>
            )}
          </Nav>

          <Nav className="align-items-center">
            {!isAuthenticated ? (
              <>
                <Nav.Link as={Link} to="/login" className="nav-link-custom">
                  Login
                </Nav.Link>
                <Button 
                  as={Link} 
                  to="/signup" 
                  variant="primary" 
                  className="ms-2"
                  style={{ borderRadius: '0.5rem' }}
                >
                  Sign Up
                </Button>
              </>
            ) : (
              <Dropdown align="end">
                <Dropdown.Toggle variant="link" className="nav-link-custom text-decoration-none d-flex align-items-center">
                  <FiUser className="me-1" />
                  {user?.business?.name || user?.email?.split('@')[0] || 'Account'}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item as={Link} to="/dashboard">
                    <FiCalendar className="me-2" />
                    Dashboard
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} to="/dashboard/subscription">
                    <FiCreditCard className="me-2" />
                    Subscription
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item onClick={handleLogout}>
                    <FiLogOut className="me-2" />
                    Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
